import { render, staticRenderFns } from "./ViewDetailsAux.vue?vue&type=template&id=a4427c76"
import script from "./ViewDetailsAux.vue?vue&type=script&lang=js"
export * from "./ViewDetailsAux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports